//
//
//
//
//

export default {
	name: "Loader"
}
